// @mui
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
// components
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
// redux
import { useDispatch } from 'src/redux/store';
import { deleteReportTemplate, getReports } from 'src/redux/slices/report';
// route
import { useNavigate } from 'react-router-dom';
import { paths } from '../../routes/paths';
// locales
import { useLocales } from '../../locales';

type Props = {
  id: string;
  popover: ReturnType<typeof usePopover>;
};

export default function ReportPopover({ id, popover }: Props) {
  const { t } = useLocales();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const onEdit = () => {
    navigate(paths.report.edit(id));
  };

  const onDelete = () => {
    dispatch(deleteReportTemplate({ templateId: id })).then(() => dispatch(getReports()));
  };

  return (
    <CustomPopover
      open={popover.open}
      onClose={popover.onClose}
      arrow="right-top"
      sx={{ width: 160 }}
    >
      <MenuItem
        onClick={() => {
          popover.onClose();
          onEdit();
        }}
      >
        <Iconify icon="solar:pen-bold" />
        {t('Edit')}
      </MenuItem>

      <Divider sx={{ borderStyle: 'dashed' }} />

      <MenuItem
        onClick={() => {
          popover.onClose();
          onDelete();
        }}
        sx={{ color: 'error.main' }}
      >
        <Iconify icon="solar:trash-bin-trash-bold" />
        {t('Delete')}
      </MenuItem>
    </CustomPopover>
  );
}
